import React from 'react';
import ReactDOM from 'react-dom/client';
import { Routing } from './common/routes/Routing';
import './index.css';
import reportWebVitals from './reportWebVitals';

import { initialiseSentry } from '@airtel-lego/sentry';
import widgetLibPkg from '@airtel/air-new-buy-common-postpaid-widgets/package.json';
import designSysPkg from '@airtel/air-design-system/package.json';
import artistPkg from '@airtel/air-artist/package.json';
import omniPkg from '@airtel/omniwidget-container/package.json';
import { handleKeyboardOpen } from './common/commonUtils';

console.log(
   `%cair-widgets-library: ${widgetLibPkg.version} | air-design-system: ${designSysPkg.version} | air-artist: ${artistPkg.version} | omniwidget-container: ${omniPkg.version}`,
   'color: #e40000; font-size: 20px; font-weight: bold'
);

/*
 * initialise sentry sdk
 */
initialiseSentry({
   dsn: process.env.REACT_APP_SENTRY_DSN,
   release: `${process.env.REACT_APP_NAME}@${process.env.REACT_APP_VERSION}`,
   environment: process.env.REACT_APP_SENTRY_ENV,
   tracesSampleRate: 1,
   isDebugMode: true,
   tags: {
      appName: 'NEWBUYCOMMONPOSTPAID',
   },
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

// Remove strict mode for testing rerenders
// for more details visit https://github.com/facebook/react/issues/24502
root.render(<Routing />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

window.addEventListener('message', (e) => {
   const rendererContainer = document.getElementsByClassName('renderer-container')[0]
      ?.firstChild as HTMLElement;
   const mainSectionColumn = document.querySelectorAll(
      '[data-testid=artist-main-column]'
   );
   const footer = document.querySelectorAll('[data-testid=broadband-footer]');

   const htmlElement = document.getElementsByTagName('html');
   const bannerWidget = document.getElementById(
      'broadband_lead_page_bannerWidget'
   ) as HTMLElement;
   const breadcrumbWidget = document.getElementById(
      'broadband_lead_page_breadcrumbWidget'
   ) as HTMLElement;
   const step1Widget = document.getElementById(
      'broadband_lead_page_step1Widget'
   ) as HTMLElement;
   const faqWidget = document.getElementById('broadband_lead_page_faq') as HTMLElement;
   const tncWidget = document.getElementById('broadband_lead_page_tnc') as HTMLElement;
   const anchorActionElement = document.getElementById(
      'common_add_details_page_ConsentAnchorWidget'
   ) as HTMLElement;
   const anchorActionElementForSeoBlog = document.querySelector('[data-testid=common_postpaid_add_details_widget_ConsentAnchorSection]') as HTMLElement;
   const dividerElement = document.querySelectorAll('[data-testid=withDividerSection]');
   const consentWidgetChild = document.getElementById(
      'FAMILY_ADD_DETAILS_CHILD_PAGE_ConsentAnchorWidget_Child'
   ) as HTMLElement;
   const buttonWidget = document.getElementById(
      'common_add_details_page_confirmAddressButton_Step3'
   ) as HTMLElement;
   const nonP2pStep1 = document.getElementById(
      'common_add_details_page_StepWidget_1'
   ) as HTMLElement;
   const nonP2pStep2 = document.getElementById(
      'common_add_details_page_step1Widget'
   ) as HTMLElement;
   const nonP2pStep3 = document.getElementById(
      'common_add_details_page_step2Widget'
   ) as HTMLElement;
   const planWidget = document.getElementById(
      'common_add_details_page_AddDetailsStepWidget_Step4'
   ) as HTMLElement;
   const faqWidgetP2PwithTestId = document.querySelector('[data-testid=common_add_details_page_FaqSection]') as HTMLElement;
   const consentAnchorP2PwithTestId = document.querySelector('[data-testid=common_add_details_page_ConsentAnchorSection]') as HTMLElement;
   const TermsAndConditionsP2PwithTestId = document.querySelector('[data-testid=common_add_details_page_TermsAndConditionsSection]') as HTMLElement;
   const faqWidgetP2P = document.getElementById(
      'common_add_details_page_FaqWidgetFamilyP2P'
   ) as HTMLElement;
   const tncWidgetP2P = document.getElementById(
      'common_add_details_page_TermsAndConditionsWidgetFamily'
   ) as HTMLElement;
   const tncWidgetP2PForSeoBlog = document.querySelector('[data-testid=common_postpaid_add_details_widget_TermsAndConditionsSection]') as HTMLElement;
   const dynamicScrollListWidget = document.getElementById(
      'common_add_details_page_DynamicScrollListWidget'
   ) as HTMLElement;
   const step5ButtonWidget = document.getElementById(
      'common_add_details_page_AddDetailsStepWidget_Step5_ButtonWidget'
   ) as HTMLElement;
   const linkListItemWidget = document.getElementById(
      'common_add_details_page_AddDetailsStepWidget_Step5_LinkListitemWidget'
   ) as HTMLElement;
   const step5 = document.querySelectorAll('[data-testid=common_add_details_page_AddDetailsStepWidget_Step5]')?.[0]?.parentElement?.parentElement?.parentElement?.parentElement?.parentElement?.parentElement as HTMLElement;
   const stickyFooter = document.querySelector('[data-testid=artist-sticky-footer]') as HTMLElement;
   
   if (e?.data?.eventName == 'WtoC_EnableBackdrop') {
      htmlElement[0]?.classList?.add?.('omni-overflow');
      bannerWidget?.classList?.add?.('button-zIndex');
      breadcrumbWidget?.classList?.add?.('button-zIndex');
      step1Widget?.classList?.add?.('button-zIndex');
      faqWidget?.classList?.add?.('button-zIndex');
      tncWidget?.classList?.add?.('button-zIndex');
      dynamicScrollListWidget?.classList?.add?.('button-zIndex');
      step5ButtonWidget?.classList?.add?.('button-zIndex');
      linkListItemWidget?.classList?.add?.('button-zIndex');
      step5?.classList?.add?.('button-zIndex');
      anchorActionElement?.classList?.add?.('button-zIndex');
      rendererContainer?.classList?.add?.('zIndex');
      footer.forEach((a) => a.classList.add?.('footer'));
      dividerElement.forEach((a) => a.classList.add?.('button-zIndex'));
      mainSectionColumn.forEach((a) => a?.classList?.add('artist-main-column'));
      consentWidgetChild?.classList?.add?.('button-zIndex');
      buttonWidget?.classList?.add?.('button-zIndex');
      planWidget?.classList?.add?.('button-zIndex');
      faqWidgetP2PwithTestId?.classList?.add?.('button-zIndex');
      consentAnchorP2PwithTestId?.classList?.add?.('button-zIndex');
      TermsAndConditionsP2PwithTestId?.classList?.add?.('button-zIndex');
      faqWidgetP2P?.classList?.add?.('button-zIndex');
      tncWidgetP2P?.classList?.add?.('button-zIndex');
      tncWidgetP2PForSeoBlog?.classList?.add?.('button-zIndex');
      anchorActionElementForSeoBlog?.classList.add?.('button-zIndex');
      stickyFooter?.classList?.add?.('button-zIndex');
      nonP2pStep1?.classList?.add?.('button-zIndex');
      nonP2pStep2?.classList?.add?.('button-zIndex');
      nonP2pStep3?.classList?.add?.('button-zIndex');
   }
   if (e?.data?.eventName == 'WtoC_DisabledBackdrop') {
      htmlElement[0]?.classList?.remove?.('omni-overflow');
      bannerWidget?.classList?.remove?.('button-zIndex');
      breadcrumbWidget?.classList?.remove?.('button-zIndex');
      step1Widget?.classList?.remove?.('button-zIndex');
      faqWidget?.classList?.remove?.('button-zIndex');
      faqWidgetP2PwithTestId?.classList?.remove?.('button-zIndex');
      consentAnchorP2PwithTestId?.classList?.remove?.('button-zIndex');
      TermsAndConditionsP2PwithTestId?.classList?.remove?.('button-zIndex');
      faqWidgetP2P?.classList?.remove?.('button-zIndex');
      anchorActionElement?.classList?.remove?.('button-zIndex');
      tncWidget?.classList?.remove?.('button-zIndex');
      dynamicScrollListWidget?.classList?.remove?.('button-zIndex');
      step5ButtonWidget?.classList?.remove?.('button-zIndex');
      linkListItemWidget?.classList?.remove?.('button-zIndex');
      step5?.classList?.remove?.('button-zIndex');
      rendererContainer?.classList?.remove?.('zIndex');
      footer.forEach((a) => a.classList.remove?.('footer'));
      dividerElement.forEach((a) => a.classList.remove?.('button-zIndex'));
      mainSectionColumn.forEach((a) => a?.classList?.remove('artist-main-column'));
      consentWidgetChild?.classList?.remove?.('button-zIndex');
      buttonWidget?.classList?.remove?.('button-zIndex');
      planWidget?.classList?.remove?.('button-zIndex');
      faqWidget?.classList?.remove?.('button-zIndex');
      tncWidgetP2P?.classList?.remove?.('button-zIndex');
      tncWidgetP2PForSeoBlog?.classList?.remove?.('button-zIndex');
      anchorActionElementForSeoBlog?.classList.remove?.('button-zIndex');
      stickyFooter?.classList?.remove?.('button-zIndex');
      nonP2pStep1?.classList?.remove?.('button-zIndex');
      nonP2pStep2?.classList?.remove?.('button-zIndex');
      nonP2pStep3?.classList?.remove?.('button-zIndex');
   }
});

handleKeyboardOpen();
